export const PickerOptionTypes = {
  USER: "user",
  GROUP: "group",
  COLLECTION: "collection",
};
